import '@operato/chart/ox-property-editor-chart.js'

export default [
  {
    type: 'chartjs',
    element: 'ox-property-editor-chart'
  }
]
